import React, { useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { useLineUpMainViewContext } from '../../contexts/LineUpMainViewContext';

import LineUpRaceTrack from './LineUpRaceTrack';
import selectLineUpRaceTrackProps from './LineUpRaceTrack.selector';

const LineUpRaceTrackContainer = () => {
  const { filterId, matchId, sportId } = useLineUpMainViewContext();

  const selectorProps = useMemo(() => ({ filterId, matchId, sportId }), [filterId, matchId, sportId]);
  const selectedProps = useTypedSelector((state) => selectLineUpRaceTrackProps(state, selectorProps));

  const otherProps = useMemo(() => ({ sportId }), [sportId]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return <LineUpRaceTrack {...enhancedProps} />;
};

export default LineUpRaceTrackContainer;
